import { defineComponent, computed, toRefs } from 'vue';
export default defineComponent({
    name: 'Paging',
    props: {
        paging: {
            type: Object,
            required: true
        },
        value: {
            type: Number,
            required: true
        },
        maxViewSize: {
            type: Number,
            default: 10
        }
    },
    setup(props, { emit }) {
        const { paging, value, maxViewSize } = toRefs(props);
        const edition = computed(() => value.value / maxViewSize.value || 0);
        const pageList = computed(() => {
            const pageSize = paging.value.pages - edition.value * maxViewSize.value;
            const maxList = pageSize < maxViewSize.value ? pageSize : maxViewSize.value;
            return [...Array(maxList).keys()].map(i => i + 1 + (props.maxViewSize * edition.value));
        });
        const isFirst = computed(() => value.value === 0);
        const isLast = computed(() => value.value + 1 === paging.value.pages);
        const nextEdition = computed(() => {
            const nextPage = (edition.value + 1) * maxViewSize.value + 1;
            return nextPage > paging.value.pages ? paging.value.pages : nextPage;
        });
        const prevEdition = computed(() => {
            const prevPage = (edition.value - 1) * maxViewSize.value + 1;
            return prevPage < 1 ? 1 : prevPage;
        });
        return {
            edition,
            pageList,
            isFirst,
            isLast,
            nextEdition,
            prevEdition,
            btnAttr(page) {
                function isCurrent(p) {
                    return props.value + 1 === p;
                }
                return {
                    color: isCurrent(page) ? 'primary' : '',
                    text: !isCurrent(page),
                    dark: isCurrent(page)
                };
            },
            changePage(page) {
                if (page === props.value + 1)
                    return;
                emit('input', page);
            }
        };
    }
});
